import { useSessionStorage } from "usehooks-ts"
import { useUser } from "~/providers/userProvider"
import { isDemo } from "~/utils/environment"

/** The gate itself, without React — the testable core of `useShowInternalFeatures`. Staff is
 * the outer condition, so no stored value turns internal features on for a customer. */
export function resolveShowInternalFeatures({
  stored,
  isStaff,
  demo,
}: {
  stored: boolean | null
  isStaff: boolean
  demo: boolean
}): boolean {
  return isStaff && (stored ?? !demo)
}

export default function useShowInternalFeatures() {
  const { permissions } = useUser()
  // null = never explicitly set, so the default follows the role once the Auth0 claim lands.
  const [stored, setShowInternalFeatures] = useSessionStorage<boolean | null>(
    "show-internal-features",
    null,
  )

  const showInternalFeatures = resolveShowInternalFeatures({
    stored,
    isStaff: permissions.isStaff,
    demo: isDemo(),
  })

  return [showInternalFeatures, setShowInternalFeatures] as const
}
